export type Headers = {
  Prefer?: string
}

export const setPreferHeader = (
  UrlSearch: string,
  mockApiMode: boolean = !!import.meta.env.MODE
) => {
  const mockapiPreferStatusCode = params(UrlSearch, 'mockapiPreferStatusCode')
  const mockapiPreferExample = params(UrlSearch, 'mockapiPreferExample')

  if (mockApiMode && (mockapiPreferStatusCode || mockapiPreferExample)) {
    const headerVals = []

    if (mockapiPreferStatusCode) {
      headerVals.push(`statusCode=${mockapiPreferStatusCode}`)
    }

    if (mockapiPreferExample) {
      headerVals.push(`example=${mockapiPreferExample}`)
    }

    return { Prefer: headerVals.join(',') }
  }
}

const params = (UrlSearch: string, paramName: string) => {
  const p = new URLSearchParams(UrlSearch)
  return p.get(paramName)
}
